import { render, staticRenderFns } from "./NotionIntegration.pug?vue&type=template&id=dbd34138&lang=pug&external"
import script from "./NotionIntegration.js?vue&type=script&lang=js&external"
export * from "./NotionIntegration.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports